package com.xtream.composeapp.viewmodel

import androidx.lifecycle.ViewModel
import androidx.lifecycle.viewModelScope
import com.xtream.data_kmp.db.AppRoomDB
import com.xtream.data_kmp.db.repo.HomeStreamsRepository
import com.xtream.data_kmp.db.repo.LiveStreamsRepository
import com.xtream.data_kmp.db.repo.SeriesStreamsRepository
import com.xtream.data_kmp.db.repo.VodStreamsRepository
import com.xtream.data_kmp.db.repo.WatchedLiveRepository
import com.xtream.data_kmp.dto.BaseStream
import kotlinx.coroutines.flow.SharingStarted
import kotlinx.coroutines.flow.StateFlow
import kotlinx.coroutines.flow.combine
import kotlinx.coroutines.flow.filterNotNull
import kotlinx.coroutines.flow.stateIn
import kotlinx.coroutines.flow.zip
import org.jetbrains.compose.resources.StringResource
import com.xtream.sharedResources.resources.Res
import com.xtream.sharedResources.resources.recently_added_movies
import com.xtream.sharedResources.resources.recently_added_tv
import com.xtream.sharedResources.resources.recently_added_tv_shows
import com.xtream.sharedResources.resources.trending
import kotlin.random.Random

/*

data class HomeUiState(
    val streamInfo: StreamInfoState = StreamInfoState(),
    val isLoading: Boolean = false
    // Add your list and adState here later
)
*/

class HomeViewModel (
    private val liveStreamsRepo: LiveStreamsRepository,
     watchedLiveStreamsRepo: WatchedLiveRepository,
    private val vodStreamsRepo: VodStreamsRepository,
      seriesStreamsRepo: SeriesStreamsRepository,
    val db: AppRoomDB,
    private val homeStreamsRepository: HomeStreamsRepository
) : ViewModel() {
/*
    // 1. Private state holder
    private val _uiState = MutableStateFlow(HomeUiState())
    val uiState = _uiState.asStateFlow()

    // 2. The focus "buffer" - handles the 400ms delay automatically
    private val focusedItemRequest = MutableSharedFlow<BaseStream?>(replay = 1)

    init {
        observeFocusChanges()
    }

    private fun observeFocusChanges() {
        viewModelScope.launch {
            focusedItemRequest
                .debounce(400) // Replaces your delay(400)
                .collectLatest { item ->
                    if (item == null) return@collectLatest
                    updateStreamInfo(item)
                }
        }
    }

    fun onItemFocused(item: BaseStream?) {
        viewModelScope.launch { focusedItemRequest.emit(item) }
    }

    private suspend fun updateStreamInfo(item: BaseStream) {
        // 1. Create the initial state based on the item type
        val initialState = when (item) {
            is LiveStream -> StreamInfoState(title = item.name)

            is BaseTrending -> StreamInfoState(
                title = item.name,
                overview = item.overview,
                rating = item.voteAverage?.toString()?.formattedRating(),
                releaseDate = item.releaseDate,
                backdrop = item.backdrop.addTMDBPrefixImageURL(),
            )

            is VodStream -> {
                // Fetch info synchronously in this coroutine
                val info = vodStreamsRepo.loadInfo(item.streamId) // Assuming this is now suspend
                StreamInfoState(
                    title = item.name,
                    overview = info?.info?.plot,
                    rating = info?.info?.formattedRating(),
                    genre = info?.info?.genre,
                    releaseDate = info?.info?.releaseDate,
                    duration = info?.info?.duration,
                    backdrop = info?.info?.backdrop_path?.firstOrNull(),
                )
            }

            is SeriesStream -> {
                val info = seriesStreamsRepo.loadInfo(item.streamId) // Assuming this is now suspend
                StreamInfoState(
                    title = item.name,
                    overview = info?.info?.plot,
                    rating = info?.info?.formattedRating(),
                    genre = info?.info?.genre,
                    releaseDate = info?.info?.releaseDate,
                    backdrop = info?.info?.backdrop_path?.firstOrNull(),
                )
            }
            else -> StreamInfoState()
        }

        // 2. Immediately update UI with basic info so it feels snappy
        _uiState.update { it.copy(streamInfo = initialState) }

        // 3. Background fetch the logo if needed (Async)
        val logoId = when (item) {
            is BaseTrending -> item.id.toString()
            is VodStream -> vodStreamsRepo.getCachedTmdbId(item.streamId)
            else -> null
        }

        if (logoId != null) {
            val logo = if (item is TrendingTvShow || item is SeriesStream) {
                seriesStreamsRepo.getTMDBLogo(logoId)
            } else {
                vodStreamsRepo.getTMDBLogo(logoId)
            }

            // 4. Update only the logo part of the state
            _uiState.update { it.copy(streamInfo = it.streamInfo.copy(logoTitle = logo)) }
        }
    }*/












    /**
     * gets Top Ten Movies By Rating
     * @return [List] of [com.xtream.data.dto.VodStream]
     */
    suspend fun getTopTenVod() = vodStreamsRepo.getTopTens()


    /**
     * gets Movies By Added
     * @return [List] of [com.xtream.data.dto.LiveStream]
     */
    val recentTv = liveStreamsRepo.recentlyAddedFlow().stateIn(viewModelScope, SharingStarted.Lazily, null)




    /**
     * gets TMDB trending movies
     * @return [List] of [com.xtream.data.dto.TrendingMovie]
     */
    val trendingMovies = vodStreamsRepo.getTrendingAsFlow().stateIn(viewModelScope, SharingStarted.Lazily, null)

    /**
     * gets TMDB trending movies
     * @return [List] of [com.xtream.data.dto.TrendingTvShow]
     */
    val trendingTvShows = seriesStreamsRepo
        .getTrendingAsFlow()
        .stateIn(viewModelScope, SharingStarted.Lazily, null)

    /**
     * gets TMDB trending movies, tv shows
     * @return [List] of [com.xtream.data.dto.BaseTrending]
     */
    val trending = combine(trendingMovies, trendingTvShows) { trendingMoviesList, trendingShows ->
        val combined = (trendingMoviesList ?: emptyList()) + (trendingShows ?: emptyList())
        combined.shuffled(Random(1234)) // 1234 = fixed seed → same shuffle every time
    }.filterNotNull()


    /**
     * gets Movies By Added
     * @return [List] of [com.xtream.data.dto.VodStream]
     */
    val recentMovies = vodStreamsRepo.recentlyAddedFlow().stateIn(viewModelScope, SharingStarted.Lazily, null)

    /**
     * gets Movies By Added
     * @return [List] of [com.xtream.data.dto.SeriesStream]
     */
    val recentSeries = seriesStreamsRepo.recentlyAddedFlow().stateIn(viewModelScope, SharingStarted.Lazily, null)

    val recentMap: StateFlow<Map<StringResource, Pair<Float, List<BaseStream>>>?> = recentTv
        .zip(recentMovies) { tv, movies ->
            tv to movies
        }
        .zip(recentSeries) { prev, series ->
            // prev is Pair(tv, movies)
            Triple(prev.first, prev.second, series)
        }
        .zip(trendingMovies) { prev, tMovies ->
            // prev is Triple(tv, movies, series)
            prev to tMovies
        }
        .zip(trendingTvShows) { prev, tShows ->
            // prev is Pair(Triple(tv, movies, series), tMovies)
            val (data, tMovies) = prev
            val (tv, movies, series) = data

            val map = mutableMapOf<StringResource, Pair<Float, List<BaseStream>>>()

            // Build Trending section
            val trending = (tMovies ?: emptyList()) + (tShows ?: emptyList())
            if (trending.isNotEmpty()) {
                map[Res.string.trending] = (16 / 9f to trending)
            }

            // Build other sections
            if (!tv.isNullOrEmpty()) map[Res.string.recently_added_tv] = (1f to tv)
            if (!movies.isNullOrEmpty()) map[Res.string.recently_added_movies] = (2f / 3f to movies)
            if (!series.isNullOrEmpty()) map[Res.string.recently_added_tv_shows] = (2f / 3f to series)

            map.toMap()
        }
        .stateIn(
            scope = viewModelScope,
            started = SharingStarted.WhileSubscribed(5000),
            initialValue = null
        )




    companion object {
        const val WATCHED_LIVE_STREAMS = 1
        const val RECENTLY_ADDED_TV = 2
        const val RECENTLY_ADDED_MOVIES = 3
        const val RECENTLY_ADDED_SERIES = 4

    }
}
